// This file is generated via scripts/build-static-config.js
// Do not modify directly as changes will be overwritten in CI

export const CONFIGURATION = {
  country: 'ca',
  brand: 'th',
  env: 'prod',
  graphqlEnv: 'prod',
  graphqlGatewayEnv: '',
  sanityEnv: 'prod',
  platform: 'web',
  commitRef: '32adb28cb0da2d128fdce92a19cc0964b7357985',
  releaseTimestamp: '1791924302',
  sanityDataset: '',
  sanityProjectId: 'czqk28jt',
  appFlowBuildId: '',
  adyen: {
    clientKey: '',
    environment: '',
    urlPrefix: '',
  },
  apiKeys: {
    bringg: '',
    googleMapsWeb: 'AIzaSyAAl3l7GjBtuUtGWsHeLiUgULHfWRTiOf8',
    googleAnalytics: '',
    tomtom: '',
  },
  apple: {
    merchantId: 'merchant.com.timhortons.direct',
    migrationMerchantId: '',
    paymentsNetworks: ['AmEx','MasterCard','Visa','Discover'],
    prepaidMerchantId: 'merchant.com.timhortons',
    migrationPrepaidMerchantId: '',
  },
  aws: {
    gqlApiUrl: 'https://use1-prod-th.rbictg.com/graphql',
    gqlGatewayApiUrl: 'https://use1-prod-th-gateway.rbictg.com/graphql',
    region: 'us-east-1',
    userPoolClientId: '3fmtnokmptq4l3q7pfham4o2fn',
    userPoolId: 'us-east-1_dWLdozxFz',
  },
  bringg: {
    region: '6',
  },
  datadog: {
    logs: {
      clientToken: 'pub7be84564cb13e8d9e0bdf3b4eb9bf037',
      dataCenter: '',
    },
    rum: {
      applicationId: '9f8660ef-8e12-429f-ab6f-d0c24621166e',
      clientToken: 'pub7be84564cb13e8d9e0bdf3b4eb9bf037',
      dataCenter: '',
    },
  },
  forter: {
    siteId: '2c89dca418ce',
  },
  google: {
    paymentsEnvironment: 'prod',
    paymentsGateway: 'chase',
    paymentsGatewayMerchantId: {
      ca: '594989',
      us: '597621',
    },
    migrationPaymentsGateway: '',
    migrationPaymentsGatewayMerchantId: {
      ca: '',
      us: '',
    },
    paymentsNetworks: ['AMEX','MASTERCARD','VISA','DISCOVER','JCB'],
    prepaidPaymentsGateway: 'firstdata',
    prepaidPaymentsGatewayMerchantId: {
      ca: '311201840882',
      us: '335207214883',
    },
    migrationPrepaidPaymentsGateway: 'firstdata',
    migrationPrepaidPaymentsGatewayMerchantId: {
      ca: '',
      us: '',
    }
  },
  googleAdManager: {
    campaignId: '/22662485316/prod_timhortons/homepage',
  },
  googleTagManager: {
    containerId: 'GTM-WDB8JLW',
  },
  oneTrust: {
    cookieCompliance: {
      consentCategoryBranch: 'C0004',
      globalConsentState: 'Opt-In',
      scriptUrl: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      scriptId: 'ce698e35-19b8-4330-ba2b-8fc56b64a5e1',
    },
    deleteAccountUrl: '',
  },
  pypestream: {
    scriptUrl: 'https://web.pypestream.com/api-launcher.js',
    appId: '36b5aeff-b293-40d2-a2b7-649e5f1da536',
  },
  adobeExperience: {
    edgeConfigId: '045e5e94-60f2-4e4d-a851-39dcc866d756',
    orgId: '8150297863FF06800A495F8D@AdobeOrg',
    dtmScriptUrl: 'https://assets.adobedtm.com/8429e98f4938/afafd4983170/launch-3cdf3495b490.min.js',
  },
  restaurants: {
    displayEnv: 'prod',
    validMobileOrderingEnvs: ['alpha','beta','live'],
  },
  urls: {
    firstData: 'https://ucom.fiservapis.com',
    firstDataTh: 'https://ucom.fiservapis.com',
    webBaseUrl: '',
    thDigital: 'https://api.rbi.digital/payment',
    timShop: 'https://timshop.timhortons.ca/',
  },
  tokenEx: {
    publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA8gGPMwBRPuVyJReZGIkWH/+Bf5pnpDN1bSR2cLYLXVT8CaSnTw74qeboSnktgYCi1D9R3Bj2fYzTIwGGZb8KinLdxwbqZmHwrE9cFhCaHbG/E0PbqQGhXP2vbniZTT4M0i0Cbi7ES3Bw5zqNbIZZnX041QEpxLvIyWPKZCX+fBogNMhWfCF779aclChjHkwZMsufThVWE9xklWGxXiytx5aL4I5JPxq0I7cAkZGGs4aF/GxWwPaq7R3wPikJQ0YHnCMfcURzl2Hnw/inqyMy+JB6djTq2/BdzMAhWTh3cDWq9Xu+gEkb/QCd0n1yYIdKuDISlk/AfHdWe34IvzhVyQIDAQAB',
  },
  vrPayment: {
    braintreeTokenizationKey: '',
  },
  orbital: {
    baseUrl: '',
    subscriberId: '',
    pieFormat: '',
    mode: '',
  },
  timeFormat: '',
  dateFormat: '',
  appStoreDeeplink: 'https://timhortons-web.app.link/e/Pgw8gSlSDzb',
};